<template>
  <div class="challenge calculator_suite">
    <BannerPages
      class="max-text"
      title="calculator-suite.banner.title"
      :descriptions="[$t('calculator-suite.banner.description')]"
      :img="'/images/calculator_suite/CalculatorSuite-banner.png'"
      :imgMobile="'/images/calculator_suite/CalculatorSuite-banner.png'"
      mainImageWidthDesk="466"
      mainImageHeightDesk="471"
      :alt="$t('calculator-suite.banner.alt')"
      :buttons="[
        {
          type: 'external',
          href: getExternalUrl('/login'),
          class: 'primary-button-medium',
          text: 'calculator-suite.banner.button',
        },
      ]"
    />
    <main class="flex flex-column align-items-center justify-content-center">
      <div class="content margin-general" :style="degrade">
        <Tabs @tab-selected="handleTabSelected" />

        <div class="bg-white border-round-xl mt-3 p-2 pb-5 md:p-5">
          <LazyLotsize v-if="activeTab === 'lotsize'" />
          <LazyFibonacci v-if="activeTab === 'fibonacci'" />
          <LazyMaster v-if="activeTab === 'master'" />
          <LazyCurrency v-if="activeTab === 'currency'" />
          <LazyPivot v-if="activeTab === 'pivot'" />
          <LazyHowDoesWorkVue :activeTab="activeTab" />
        </div>

        <section class="faq-section" v-if="activeTab !== 'currency'">
          <h2 class="heading-h2 faq-title">
            {{ $t(faqTitle) }}
            <p class="body-4 mt-2">
              {{ $t("calculator-suite.faq.titles.generalDesc") }}
            </p>
          </h2>
          <LazyAccordeon :options="filteredFaqCards" class="faq-accordion" />
        </section>
      </div>
    </main>
    <client-only>
      <LazyInvestment
        label="calculator-suite.footer.hands-on"
        :buttonConfigs="[
          {
            type: 'external',
            href: getExternalUrl('/login'),
            class: 'primary-button-medium',
            textKey: 'calculator-suite.footer.gotoCabinet',
          },
          {
            type: 'external',
            href: getExternalUrl('/register'),
            class: 'second-button-medium-white',
            textKey: 'calculator-suite.footer.openAccount',
          },
        ]"
      />
    </client-only>
  </div>
  <TiersDetailsModal :isVisible="isVisible" @close="isVisible = false" />
</template>

<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import { useImage } from "#imports";
import LazyHowDoesWorkVue from "~/components/calculator-suite/HowDoesItWork.vue";
import LazyAccordeon from "~/components/Accordeon";
import TiersDetailsModal from "~/components/gold_challenge/TiersDetailsModal.vue";
import {
  lotSizeFaq,
  masterFaq,
  fibonnaciFaq,
  pivotFaq,
} from "~/components/calculator-suite/utils/faqCards";
import LazyInvestment from "~/components/Investment.vue";
import { useExternalUrl } from "@/composables/useExternalUrl";
import Tabs from "~/components/calculator-suite/Tabs.vue";
import LazyFibonacci from "~/components/calculator-suite/Fibonacci.vue";
import LazyLotsize from "~/components/calculator-suite/Lotsize.vue";
import LazyMaster from "~/components/calculator-suite/Master.vue";
import LazyCurrency from "~/components/calculator-suite/Currency.vue";
import LazyPivot from "~/components/calculator-suite/Pivot.vue";

const nuxtImg = useImage();
const { t } = useI18n();
const activeTab = ref("lotsize");

const degradadeImageUrl = "/images/calculator_suite/gradient.avif";

const optimizedDegrade = nuxtImg(degradadeImageUrl, {
  quality: 50,
  format: "avif",
});

const degrade = computed(() => {
  return {
    "--degrade": `url('${optimizedDegrade}')`,
  };
});

const filteredFaqCards = computed(() => {
  switch (activeTab.value) {
    case "lotsize":
      return lotSizeFaq;
    case "master":
      return masterFaq;
    case "fibonacci":
      return fibonnaciFaq;
    default:
      return pivotFaq;
  }
});

const handleTabSelected = (tabName) => {
  activeTab.value = tabName;
};

const faqTitle = computed(() => {
  if (activeTab.value === "lotsize") {
    return "calculator-suite.faq.titles.lot";
  } else {
    return "calculator-suite.faq.titles.general";
  }
});

const { getExternalUrl } = useExternalUrl();
const isVisible = ref();

const title = t("seo.calculator-suite.title");
const description = t("seo.calculator-suite.description");
const imgSeo = "https://tradeview.eu/images/seo/38CalculatorSuite.jpg";

useSeoMeta({
  title: title,
  ogTitle: title,
  twitterTitle: title,
  description: description,
  ogDescription: description,
  twitterDescription: description,
  ogImage: imgSeo,
  twitterImage: imgSeo,
});
</script>
